import "./Chart.scss"
import React from "react"
import moment from "moment"
import { memoize } from "lodash"
import { observer } from "mobx-react"
import { Redirect } from "react-router-dom"
import { Card } from "../../lib"
import Analytics from "../../assets/01/svgs/analytics.svg"
import { teamStore } from "../../app/stores"
import { CartesianGrid, LineChart, Line, XAxis, YAxis } from "recharts"

const axisProps = {
  axisLine: false,
  tickLine: false,
  height: 50,
  width: 50,
}

const getChartData = memoize(analytics => {
  const today = moment().date()
  const daysInMonth = moment().daysInMonth()
  return Array(daysInMonth)
    .fill(null)
    .map((_, index) => {
      const date = index + 1
      const defaultValue = today > date ? 0 : null
      return {
        count: analytics[date] || defaultValue,
        label: moment()
          .date(date)
          .format("MMM Do"),
      }
    })
})

const Chart = () => {
  if (teamStore.team && teamStore.activeChannels.length < 1) {
    return <Redirect to="/add" />
  }
  if (!teamStore.team) {
    return null
  }
  if (!teamStore.team.channels) {
    return (
      <Card title="You haven’t created any channels yet" img={Analytics}>
        To get started add a channel.
      </Card>
    )
  } else if (!teamStore.analytics) {
    return (
      <Card title="Your Monthly Analytics" img={Analytics}>
        You’ll be able to track your monthly conversations and messages here
      </Card>
    )
  } else {
    const data = getChartData(teamStore.analytics)
    return (
      <div className="Chart">
        <header>
          <h2>{moment().format("MMMM")}</h2>
          <div>
            <p>{teamStore.sessionsToday} conversations today</p>
            <p>{teamStore.sessionsThisMonth} conversations this month </p>
          </div>
        </header>
        <LineChart
          data={data}
          width={800}
          height={300}
          margin={{ top: 50, right: 50, left: 0, bottom: 0 }}>
          <CartesianGrid stroke="white" vertical={false} />
          <Line
            dataKey="count"
            type="monotone"
            stroke="#2C2C46"
            strokeWidth="2"
            dot={false}
          />
          <XAxis
            {...axisProps}
            dataKey="label"
            interval={5}
            // axisLine={{ stroke: '#2C2C46', strokeWidth: 2 }}
            stroke="#2C2C46"
            padding={{ left: 40, right: 40 }}
          />
          <YAxis {...axisProps} interval={2} padding={{ top: 5, bottom: 40 }} />
        </LineChart>
      </div>
    )
  }
}

Chart.displayName = "Chart"

export default observer(Chart)



// WEBPACK FOOTER //
// ./src/dashboard/analytics/Chart.js